import { CommonQuestionKeys } from '@bybeam/platform-types';
import STANDARD_COMPONENTS from '../standards/index.js';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

// Add mailing address question
CONFIG.sections
  .find(({ key }) => key === 'youAndYourSituation')
  .questionGroups[0].questions.push(
    STANDARD_COMPONENTS.definitions.questions[CommonQuestionKeys.MAILING_ADDRESS],
  );

// Add subheader to document upload question
const documentsSection = CONFIG.sections.find(({ key }) => key === 'documents');
documentsSection.questionGroups[0].questions[0].copy.intro = `Please upload supporting documents related to the challenge area(s) indicated in your application. This is a required step.

If you are a third year student and you have not sent the following documents this semester, please do so for our records:
- SAR
- Transcript (unofficial)
- Class Schedule
- Semester Bill/Award Letter`;

export default CONFIG;
